/**
 * Created by wiki on 2017/2/27.
 */
import * as types from './mutation-types'
// import apinew from '../api/apinew'
import config from 'config/apiConfig'
import axios from 'axios'

export const actions = {
  setAppId({commit}, appid){
    commit(types.SET_APPID, {
      appid: appid
    })
  },

  fetchStores({commit}){
    return new Promise((resolve, reject) => {
      api.shopManage.queryShop(resp => {
        commit(types.SET_STORES, {
          stores: resp.data
        })
        resolve();
      })
    })
  },

  fetchUser({commit}){
    return new Promise((resolve, reject) => {
      apinew.user.getUserInfo({},resp => {
        commit(types.SET_USERWX, {
          userwx: resp.data
        });
        resolve();
      },error=>{
      })
    })
  },

  fetchGatewayversion({commit}){
    return new Promise((resolve, reject) => {
      apinew.user.getUserInfo({},resp => {
        commit(types.SET_GATEWAYVER, {
          gatewayversion: resp.info
        });
        resolve();
      },error=>{
      })
    })
  },


  fetchGatewayversion({commit}){
    return new Promise((resolve, reject) => {
      apinew.gatewayversion({},resp => {
        commit(types.SET_GATEWAYVER, {
          gatewayversion: resp.info
        });
        resolve();
      },error=>{
        reject();
      })
    })
  },

  fetchGatewaytype({commit}){
    return new Promise((resolve, reject) => {
      apinew.gatewaytype({},resp => {
        commit(types.SET_GATEWAYTYPE, {
          gatewaytype: resp.info
        });
        resolve();
      },error=>{
        reject();
      })
    })
  },

  
  showNameTabs(store,payload){
    store.commit(types.SHOW_NAME_TABS,{
      store:store,
      nameTabs:payload
    });
  },

  changeAddmeauDataOnline(store,payload){
    store.commit(types.CHANGE_ADDMEAU_DATA_ONLINE,{
      store:store,
      payload:payload
    });
  },
  changeWarranty(store,payload){
    store.commit(types.CHANGE_WARRANTY,{
      store:store,
      payload:payload
    })
  },
  changeAddmeauDataOpen(store,payload){
    store.commit(types.CHANGE_ADDMEAU_DATA_OPEN,{
      store:store,
      payload:payload
    });
  },

  changeSearchNumber(store,payload){
    store.commit(types.CHANGE_SEARCH_NUMBER,{
      store:store,
      payload:payload
    });
  },
};


export const mutations = {
  [types.SET_APPID] (state, {appid}) {
    state.appid = appid
  },
  [types.SET_STORES] (state, {stores}) {
    state.stores = stores
  },
  [types.SET_USERWX] (state, {userwx}) {
    state.userwx = userwx
  },

  [types.SET_GATEWAYVER] (state, {gatewayversion}) {
    state.gatewayversion = gatewayversion
  },

  [types.SET_GATEWAYTYPE] (state, {gatewaytype}) {
    state.gatewaytype = gatewaytype
  },


  [types.SHOW_NAME_TABS] (state, payload) {
    state.nameTabs = payload.nameTabs;
    //if(payload.nameTabs == 'addmeauOne'){
      //state.searchNumber = state.addmeauDataOnline.length 
    //}
    //if(payload.nameTabs == 'addmeauTwo'){
      //state.searchNumber  = state.addmeauDataOpen.length
    //}
  },
  [types.CHANGE_ADDMEAU_DATA_ONLINE] (state, payload) {
    let paramsData = {
    "serialCode":'',
    "categoryCode":'',
    "shopsign":'',
    "reelNo":'',
    }
    if(payload.payload != '' && typeof payload.payload == 'object'){
      paramsData = {
        "serialCode": payload.payload[0].val,
        "categoryCode": payload.payload[1].val,
        "shopsign": payload.payload[2].val,
        "reelNo": payload.payload[3].val,
      }
    }
    if(payload.payload != '' && typeof payload.payload == 'number'){
      paramsData = {
        "serialCode":'',
        "categoryCode":'',
        "shopsign":'',
        "reelNo":'',
        "offset": state.addmeauDataOnline.length,
        "limit":'10',
      }
      if(state.addmeauDataOnline.length%10 != 0)return;
      if(state.searchNumber%10 == 0 && state.addmeauDataOnline.length == state.searchNumber)return;
      axios.post(config.queryStockOnHand,paramsData).then(function(response){
        if(response.data.resultCode == '1'){
          state.addmeauDataOnline = state.addmeauDataOnline.concat(response.data.resultData);
          state.addmeauDataOnlineRes = 0;
          for(var i=0;i<state.addmeauDataOnline.length;i++){
            state.addmeauDataOnlineRes+=parseInt(state.addmeauDataOnline[i].primaryQty)
            // alert(1111111111)

          }
        }
      })
        .catch(function (error) {
          console.log(error)
        });
        return
    }
    axios.post(config.queryStockOnHand,paramsData).then(function(response){
      if(response.data.resultCode == '1'){
        state.addmeauDataOnline = response.data.resultData;
        state.addmeauDataOnlineRes = 0;
        console.log(response.data.page.totalPageCount)
        // if(response.data.page.totalPageCount%10!=0){
        //   alert('加载完毕')
        // }
        for(var i=0;i<state.addmeauDataOnline.length;i++){
          state.addmeauDataOnlineRes+=parseInt(state.addmeauDataOnline[i].primaryQty)
            // console.log(state.addmeauDataOnline[i].orderNo)
            // if(state.addmeauDataOnline[i].orderNo==null){
            //   // state.push(null)
            //   // alert(null)
            // }
        }
        if(response.data.page != null){
          state.searchNumber = response.data.page.totalPageCount;
          sessionStorage.setItem('addmeau', JSON.stringify(response.data.page.totalPageCount));
        }
      }
    })
      .catch(function (error) {
        console.log(error)
      });
  },
  // addmeauDataOnline方法结束
  [types.CHANGE_WARRANTY] (state, payload) {
    let paramsData = {
        "limit":"10",
        "offset":"2"
    }
    if(payload.payload != '' && typeof payload.payload == 'object'){
      paramsData = {
        "limit": payload.payload[0].val,
        "offset": payload.payload[1].val
      }
    }
    // if(payload.payload != '' && typeof payload.payload == 'number'){
    //   paramsData = {
    //     "offset": state.warranty.length,
    //     "limit":'10',
    //   }
    //   if(state.warranty.length%10 != 0)return;
    //   if(state.searchNumber%10 == 0 && state.warranty.length == state.searchNumber)return;
    //   axios.post('/api/bgm/zl/zlgz/queryStockOnHand',paramsData).then(function(response){
    //     console.log(response)
    //     state.warranty = state.warranty.concat(response.data.resultData);
    //   })
    //     .catch(function (error) {
    //       console.log(error)
    //     });
    //     return
    // }
    axios.post(config.OnHand,paramsData).then(function(response){
      state.warranty = response.data.resultData;
      if(response.data.page != null){
        state.searchNumber = response.data.page.totalPageCount;
      }
    })
      .catch(function (error) {
        console.log(error)
      });
  },
    // changeaddmeaydata方法开始
  [types.CHANGE_ADDMEAU_DATA_OPEN] (state, payload) {
    let paramsData = {
    "serialCode":'',
    "categoryCode":'',
    "shopsign":'',
    "reelNo":'',
    }
    if(payload.payload != '' && typeof payload.payload == 'object'){
      paramsData = {
        "serialCode": payload.payload[0].val,
        "categoryName": payload.payload[1].val,
        "shopsign": payload.payload[2].val,
        "reelNo": payload.payload[3].val,
      }
    }
    if(payload.payload != '' && typeof payload.payload == 'number'){
      paramsData = {
        "serialCode":'',
        "categoryCode":'',
        "shopsign":'',
        "reelNo":'',
        "customerId": "1009",
        "lang": "en",
        "offset": state.addmeauDataOpen.length,
        "limit":'10',
      }
      // 实例
      if(state.addmeauDataOpen.length%10 != 0)return;
      if(state.searchNumber%10 == 0 && state.addmeauDataOpen.length == state.searchNumber)return;
      axios.post(config.bbb,paramsData).then(function(response){
        console.log(response)
        if(response.data.resultCode == '1'){
          state.addmeauDataOpen = state.addmeauDataOpen.concat(response.data.resultData);
          state.addmeauDataOpenRes = 0;
          for(var i=0;i<state.addmeauDataOpen.length;i++){
            state.addmeauDataOpenRes+=parseInt(state.addmeauDataOpen[i].primaryQty)
          }
        }
      })
        .catch(function (error) {
          console.log(error)
        });
        return
    }
    axios.post(config.OutStock,paramsData).then(function(response){
      if(response.data.resultCode == '1'){
        if(response.data.page != null){
          state.searchNumber = response.data.page.totalPageCount;
          sessionStorage.setItem('addmeauTwo', JSON.stringify(response.data.page.totalPageCount));
        }
        state.addmeauDataOpen = response.data.resultData;
        state.addmeauDataOpenRes = 0;
        for(var i=0;i<state.addmeauDataOpen.length;i++){
          state.addmeauDataOpenRes+=parseInt(state.addmeauDataOpen[i].primaryQty)
        }
      }
    })
      .catch(function (error) {
        console.log(error)
      });
  },

  [types.CHANGE_SEARCH_NUMBER] (state, payload) {
    console.log(payload.payload)
    if (sessionStorage.getItem(payload.payload)) {
      state.searchNumber = JSON.parse(sessionStorage.getItem(payload.payload));
    }

  },
};



// WEBPACK FOOTER //
// ./src/store/actions.js